export const TITLES = [
  {
    id: "breaking-the-professors-rule",
    title: "Breaking the Professor's Rule",
    genre: "Highschool Romance / Mafia Drama",
    year: "MMXXVI",
    poster:
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/bmelewfg_Professor.png",
    teasers: [
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/ayar8cbg_Professor%20teaser%201.mp4",
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/o2t57d0j_Professor%20teaser%202.mp4",
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/ridnfh6a_Professor%20teaser%203.mp4",
    ],
  },
  {
    id: "in-his-cold-eyes",
    title: "In His Cold Eyes",
    genre: "Sports Drama",
    year: "MMXXVI",
    poster:
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/f24s9j78_In_His_Cold_Eyes.png",
    teasers: [
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/ynypw7dk_In%20His%20Cold%20Eyes%20teaser%201.mp4",
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/h17uk1qi_In%20His%20Cold%20Eyes%20teaser%202.mp4",
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/4rpu8jpz_In%20His%20Cold%20Eyes%20teaser%203.mp4",
    ],
  },
  {
    id: "call-me-gianni-babygirl",
    title: "Call Me Gianni Babygirl",
    genre: "Mafia Drama",
    year: "MMXXVI",
    poster:
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/ggfoht67_Gianni.png",
    teasers: [
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/6axr4f6t_Gianni%20teaser%201.mp4",
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/8e2y1pie_Gianni%20teaser%202.mp4",
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/ih0fy1za_Gianni%20teaser%203.mp4",
    ],
  },
  {
    id: "thin-ice",
    title: "Thin Ice",
    genre: "Sports Drama",
    year: "MMXXVI",
    poster:
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/a7udmz2w_Thin_Ice.jpg",
    teasers: [
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/8c51dfln_Thin%20Ice%20teaser%201.mp4",
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/506qbb58_Thin%20Ice%20teaser%202.mp4",
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/ibqarpcx_Thin%20Ice%20teaser%203.mp4",
    ],
  },
  {
    id: "sharper-than-blade",
    title: "Sharper Than Blade",
    genre: "Sports Drama / Mafia Drama",
    year: "MMXXVI",
    poster:
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/ik3f778o_Sharper_Than_Blade.png",
    teasers: [],
  },
  {
    id: "offside",
    title: "Offside",
    genre: "Sports Drama",
    year: "MMXXVI",
    poster:
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/kuq3cr8b_Offside.jpg",
    teasers: [],
  },
  {
    id: "harder-than-diamonds",
    title: "Harder Than Diamonds",
    genre: "Mafia Drama",
    year: "MMXXVI",
    poster:
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/dvn81u31_Harder_Than_Diamonds.png",
    teasers: [],
  },
  {
    id: "mothers-choice",
    title: "Mother's Choice",
    genre: "Family Drama",
    year: "MMXXVI",
    poster:
      "https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/bi8ld2w6_Mother%27s%20choice.png",
    teasers: [],
  },
];

// Titles rendered on-screen: everything with a poster.
export const VISIBLE_TITLES = TITLES.filter((t) => Boolean(t.poster));
